import '../favicon.ico';
import '@fortawesome/fontawesome-free/js/all';
//import '../style/main.scss';

import Navigator from 'app';
import './apps/loading/loading_app';
import './apps/error/error_app';
import './apps/welcome/welcome_app';
import './apps/navbar/navbar_app';
import './apps/about/about_app';
import './apps/bills/bills_app';
import './apps/members/members_app';
import './apps/journal/journal_app';
window.N = Navigator;
Navigator.start();